import { Input, StackProps, Text, VStack } from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { Course } from "../../const/types";
import NotFound from "../NotFound";
import CourseListItemDetail from "./CourseListItemDetail";

interface Props extends StackProps {
  data: Course[];
}

export default function ListCourseDashboard({ data, ...props }: Props) {
  const [search, setSearch] = useState<string>("");
  const [filteredData, setFilteredData] = useState(data);
  useEffect(() => {
    const searchTerm = search.toLowerCase();
    const filtered = data.filter(
      (data) =>
        data.id.toString().includes(searchTerm) ||
        data.nama_course.toLowerCase().includes(searchTerm)
    );
    setFilteredData(filtered);
  }, [search, data]);

  return (
    <VStack borderRadius={8} bg={"white"} align={"stretch"} gap={0} {...props}>
      <VStack gap={0} p={4} align={"stretch"}>
        <Text fontWeight={500} mb={2}>
          Course
        </Text>
        <Input
          placeholder="Pencarian"
          onChange={(e) => {
            setSearch(e.target.value);
          }}
          value={search}
        />
      </VStack>

      <VStack gap={0} align={"stretch"} overflowY={"auto"}>
        {filteredData && filteredData.length === 0 && <NotFound />}
        {filteredData &&
          filteredData.length > 0 &&
          filteredData.map((course, i) => (
            <CourseListItemDetail key={i} data={course} />
          ))}
      </VStack>
    </VStack>
  );
}
